export default [{
    text: 'Первая',
    value: 'first'
}, {
    text: 'Вторая',
    value: 'second'
}, {
    text: 'Иная',
    value: 'other'
}];
